export const IconGrayStatusLabel: {
  name: 'icon_gray_status_label-b7cc6047b083'
} = {
  name: 'icon_gray_status_label-b7cc6047b083'
}
